import React from 'react'
import './Loader.scss'

const Loader = () => {
  return <div className='custom-loader'></div>
}

export default Loader
